import { createAction } from "@reduxjs/toolkit";
import { CHAT_ACTIONS } from "../../types";

export const resetOpponentLastTypingTime = createAction(
  CHAT_ACTIONS.RESET_OPPONENT_LAST_TYPING_TIME
);
